import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filtroTipo'
})
export class FiltroTipoPipe implements PipeTransform {

  transform(value: any[], dato: string): any[] {
    let newArr=[]
    
    newArr = value.filter(v => v.Tipo.indexOf(dato)>-1 || v.Tipo.indexOf(dato)>-1 || v.Tipo.indexOf(dato)>-1 )

    return newArr
  }

}
